import type { OmniMates } from './omniMates.types'
import { getRandomId } from '@merels/game-logic'
import { makeActiveOmniMate } from '../activeOmniMate'

/**
 * Default names for Omni mates. Limited to first 10 names.
 */
export const OMNI_MATE_NAMES = [
  'Alice',
  'Bob',
  'Charlie',
  'Debbie',
  'Elijah',
  'Faye',
  'Grace',
  'Hector',
  'Ivy',
  'Jamal',
]

export interface OmniMatesDeps {}

export function makeOmniMates(_deps: OmniMatesDeps = {}): OmniMates {
  const activeOmniMate = makeActiveOmniMate({})

  function getNextOmniMateName(existingNames: string[], currentMateCount: number): string {
    const existing = new Set(existingNames.map((n) => String(n || '').toLowerCase()))
    const next = OMNI_MATE_NAMES.find((n) => !existing.has(n.toLowerCase()))
    return next || `Mate ${currentMateCount + 1}`
  }

  function getDefaultOmniMates(): Array<{ mateId: string; name: string }> {
    // Keep default roster small and deterministic (used by Omni mode bootstrap).
    const names = OMNI_MATE_NAMES.slice(0, 2)
    return names.map((name) => ({
      mateId: `test:${name.toLowerCase()}`,
      name,
    }))
  }

  function createOmniMate(existingNames: string[], currentMateCount: number): { mateId: string; name: string } {
    const name = getNextOmniMateName(existingNames, currentMateCount)
    // If name is from our default list, keep a stable deterministic id; otherwise generate one.
    const fromList = OMNI_MATE_NAMES.some((n) => n.toLowerCase() === name.toLowerCase())
    return {
      mateId: fromList ? `test:${name.toLowerCase()}` : `test:${getRandomId(8)}`,
      name,
    }
  }

  return {
    activeOmniMate,
    maxOmniMates: OMNI_MATE_NAMES.length,
    getNextOmniMateName,
    getDefaultOmniMates,
    createOmniMate,
  }
}
